import { Box, Card, CardContent, Chip, Divider, FormControl, FormControlLabel, Grid, Paper, Radio, RadioGroup, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useCallback, useEffect, useState } from "react";
import { getVendorEnquiries } from "services/vendorDashboard";


export default function VendorEnquiries({vendorId}) {
  
  const { enqueueSnackbar } = useSnackbar();
  const [enquiries, setEnquiries] = useState(null);
  const [filteredStatus, setFilteredStatus] = useState('');

  const getEnquiries = useCallback((vendorId) => {
    getVendorEnquiries({}, {}, {vendorId}).then(({response, error}) => {
      if(response){
        setEnquiries(response);
      } else {
        setEnquiries([]);
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }, [enqueueSnackbar]);
  
  useEffect(() => {
    if(vendorId){
      getEnquiries(vendorId);
    }
  }, [getEnquiries, vendorId]);
  
  return (
    <Paper sx={{ minWidth: 275, py: 2, px: 3, minHeight: "calc(100vh - 100px )" }} elevation={0}>
     
      <Box noValidate>
        <Grid container columnSpacing={4} rowSpacing={2} >
          {/* <Grid item xs={12} sm={12} md={12} xl={12} lg={12} mb={1}>
            <Paper elevation={0} sx={{p:1, bgcolor: "#f3f3f3"}}>
              <Typography variant="subtitle2" gutterBottom component="div">
                Filters
              </Typography>
              <Box sx={{mt: 1}}>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="Filter by status"
                    name="status-group"
                    defaultValue=""
                    onChange={(event) => setFilteredStatus(event.target.value)}
                  >
                    <FormControlLabel  value="" control={<Radio />} label="All" />
                    <FormControlLabel value="Open" control={<Radio />} label="Open" />
                    <FormControlLabel value="Closed" control={<Radio />} label="Closed" />
                  </RadioGroup>
                </FormControl>
              </Box>
            </Paper>
          </Grid> */}
          {(enquiries || []).map((enquiry, index) =>( filteredStatus === "" || enquiry.status === filteredStatus) ? (
            <Grid item xs={10} sm={6} md={6} xl={3} lg={4} key={index} >
              <Card sx={{  position: 'relative',  height: '100%'}} >
                <Chip label={enquiry.status || 'Open'} color="primary" sx={{position: 'absolute', top: '8px', right: '8px'}} />
                <CardContent>
                  <Typography gutterBottom variant="body1" component="div">
                    {enquiry.name}
                  </Typography>
                  <Typography gutterBottom variant="body2" component="div">
                    {enquiry.mobileNumber}  
                  </Typography>
                 
                  <Typography gutterBottom variant="caption" component="div" color="primary.dullBlack">
                    Follow up on {enquiry.followUpDate}
                  </Typography>

                </CardContent>
              </Card>
            </Grid>
          ): null)}
          {enquiries?.length === 0 ? (
            <Typography color="error" variant="h5" component="h5"> No data found</Typography>
          ): null}
        </Grid>
      </Box>
    </Paper>
  );
}
